import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { GlobalService } from '../../core';
import { GlobalNamespace as _GlobalNS } from '../../../environments/environment';
import { ChangeLog } from './models';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ChangelogService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };
  constructor(private _http: HttpClient, private _global: GlobalService) { }

  /*
  Get Change log -> Additional Data of Property field
  */
  findByPropertyId(detailDisplayConfigId: number): Observable<ChangeLog> {
    const propertyId = this._global.find((<any>_GlobalNS).paths.PropertyId);
    const api = (<any>_GlobalNS).api.changelog.property;
    const params = new HttpParams()
      .set('propertyId', propertyId.toString())
      .set('detailDisplayConfigId', detailDisplayConfigId.toString());
    return this._http.get<any>(`${api}`, { params }).pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  }
}
